__turbopack_context__.v({
  "className": "ivyjournal_d6eb2e9f-module__wsO4-a__className",
  "variable": "ivyjournal_d6eb2e9f-module__wsO4-a__variable",
});
